import React from 'react'
import AdminLayout from 'cms/core/shared/AdminLayout'
import JobTypeList from '../components/JobTypeList'

function JobTypeScreen() {
  return (
    <AdminLayout pageTitle="Job Types">
      <JobTypeList />
    </AdminLayout>
  )
}

export default JobTypeScreen

